import InvoicesLayout from "../layouts/InvoicesLayout";

const Invoices = () => {
  return (
    <div className="p-8 bg-gray-100">
      <InvoicesLayout />
    </div>
  );
};

export default Invoices;
